import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class FileLinkDef {
  key?: string = uuid()
  type: 'file-link' = 'file-link'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: FileLinkOptions = new FileLinkOptions()
  rules?: Rule[]
}

export class FileLinkOptions {
  props?: any
  defaultValue?: any[]
  disabled?: DisabledType = false
  labelWidth?: string | number
  type?: 'primary' | 'success' | 'warning' | 'danger' | 'info' = 'primary'
  downloadFn?: () => Promise<any>
}
